var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"copyright",attrs:{"tabindex":"0"}},[_vm._v(" © "),_c('span',{staticClass:"copyright copyright_author",class:{ copyright_author_hidden: _vm.hiddenText }},[_vm._t("default",function(){return [_vm._v("Tom Grotta")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }